// extracted by mini-css-extract-plugin
export default {"main":"UtilsPage_main__8-5KW","tabs":"UtilsPage_tabs__WlKuv","block":"UtilsPage_block__G3vq4","flex":"UtilsPage_flex__f5Nt5","svg":"UtilsPage_svg__eO1VI"};